import classNames from "classnames";
import { Icon } from "@circle-react-shared/Icon";

export interface DefaultLoaderProps {
  center?: boolean;
  className?: string;
}

export const DefaultLoader = ({
  className = "",
  center = false,
}: DefaultLoaderProps) => (
  <div
    data-testid="default-loader"
    className={classNames(
      "react-loader default-loader",
      {
        "m-auto": center,
      },
      className,
    )}
  >
    <Icon type="loader" />
  </div>
);
